import React from 'react';
import ReactDOM from 'react-dom';
// ReactRenderer every card layer react instance correspond one
// to manage react life cycle
var ReactRenderer = /** @class */ (function () {
    function ReactRenderer(adapter, klass, container) {
        var _this = this;
        this.replaceProps = function (props, callback) {
            _this.props = {};
            _this.setProps(props, callback);
        };
        this.klass = klass;
        this.container = container;
        this.props = {};
        this.component = null;
        this.adapter = adapter;
    }
    ReactRenderer.prototype.setProps = function (partialProps, callback) {
        if (this.klass === null) {
            console.warn('setProps(...): Can only update a mounted or ' +
                'mounting component. This usually means you called setProps() on ' +
                'an unmounted component. This is a no-op');
            return;
        }
        this.props = Object.assign({}, this.props, partialProps);
        var element = React.createElement(this.klass, this.props);
        this.component = ReactDOM.render(element, this.container, callback) || null;
    };
    ReactRenderer.prototype.unmount = function () {
        if (!this.container) {
            console.warn('unmount(void):void: Can only unmount when container exist');
            return;
        }
        ReactDOM.unmountComponentAtNode(this.container);
        this.klass = null;
    };
    ReactRenderer.prototype.uninstall = function () { };
    return ReactRenderer;
}());
export { ReactRenderer };
//# sourceMappingURL=render-bridge.js.map